// extracted by mini-css-extract-plugin
export default {"parentContainer":"OpacityTrigger__parentContainer___0zCY0","childContainer":"OpacityTrigger__childContainer___JSAkb"};